<template>
    <div class="my-2">
        <p v-if="state.proof_source === 'manual_image'" class="text-muted mb-1">1. Välj hälsningsbild → 2. Skapa korr → 3. Godkänn korr → 4. Skapa tryckfil → 5. Ladda ner tryckfil</p>
        <p v-else class="text-muted mb-1">1. Designa hälsning → 2. Skapa korr → 3. Godkänn korr → 4. Skapa tryckfil → 5. Ladda ner tryckfil</p>
        <p v-if="message" :class="['alert', 'alert-' + message.type, 'mb-2']" :role="message.type === 'danger' ? 'alert' : 'status'">
            {{ message.text }}
            <template v-if="message.approval">
                <a :href="approved.url" target="_blank" rel="noopener">{{ approvedDate }}</a>
                <span v-if="approved.approved_by_name"> · {{ approved.approved_by_name }}</span>
                <span v-if="approvedPrintFormat" class="d-block">Tryckformat: {{ approvedPrintFormat }}</span>
            </template>
        </p>
    </div>
</template>
<script>
import { productionState } from '@services/GreetingProductionApi';

export default {
    props: {
        state: { type: Object, required: true },
        manualImage: { type: Boolean, default: false },
        error: { type: String, default: '' },
        notice: { type: String, default: '' },
    },
    computed: {
        production() { return productionState(this.state); },
        proof() { return this.production.proof; },
        approved() { return this.production.approved; },
        approvedDate() { return this.approved?.approved_at ? new Date(this.approved.approved_at).toLocaleString('sv-SE') : ''; },
        approvedPrintFormat() {
            const width = Number(this.approved?.print_geometry?.w);
            const height = Number(this.approved?.print_geometry?.h);
            return Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0 ? `${width}x${height}` : '';
        },
        needsProof() { return this.production.needsProof; },
        message() {
            if (this.error) return { type: 'danger', text: this.error };
            if (this.notice) return { type: 'success', text: this.notice };
            if (this.state.unsaved_source_selection) return { type: 'warning', text: 'Spara ordern för att använda det ändrade bildvalet i korr- och tryckflödet.' };
            if (this.state.unsaved_design_changes && this.approved) {
                return { type: 'warning', text: 'Designen har osparade ändringar. Om du sparar återkallas godkännandet och ett nytt korr behöver skapas.' };
            }
            if (this.needsProof && this.state.requires_new_proof) {
                return {
                    type: 'warning',
                    text: this.state.proof_source === 'manual_image' || this.proof?.source === 'manual_image'
                        ? 'Hälsningsbilden har ändrats. Skapa och godkänn ett nytt korr innan du skapar tryckfil.'
                        : 'Designen har ändrats. Skapa och godkänn ett nytt korr innan du skapar tryckfil.',
                };
            }
            if (this.production.step === 'needs_approval' && this.approved) {
                return { type: 'warning', text: 'Ett nytt korr väntar på godkännande. Tidigare godkänt korr används för tryck tills det nya godkänns.' };
            }
            if (this.approved && this.state.changed_since_approval) {
                return { type: 'warning', text: 'Hälsningen har ändrats efter godkännandet. Tryckfilen använder fortfarande det godkända korret.' };
            }
            if (this.needsProof) {
                if (this.state.proof_source === 'manual_image') return { type: 'warning', text: 'Den valda hälsningsbilden används som underlag. Skapa ett korr och godkänn det innan du skapar tryckfil. Ta bort vald bild för att använda en egen design.' };
                if (this.state.has_draft) return { type: 'warning', text: 'Ett designutkast är sparat. Skapa ett korr från den sparade designen.' };
                if (this.manualImage) return { type: 'warning', text: 'Ta bort befintlig hälsning för att skapa en egen design och därefter korr.' };
                return { type: 'warning', text: 'Korr och tryckfil kräver en sparad design. Text och logotyp på ordern kan hämtas in i designverktyget.' };
            }
            if (this.production.step === 'needs_approval') return { type: 'warning', text: 'Korret är sparat. Granska och godkänn det innan du skapar tryckfil.' };
            return { type: 'success', text: 'Godkänt korr:', approval: true };
        },
    },
};
</script>
